import React, { ComponentProps, FC, ReactNode } from "react";
import { AlertDialog } from "../dialog/alert";
import { ConfirmDialog } from "../dialog/confirm";
import { Modal } from "../modal";
import { labels } from "./labels";

export type IProductValidationDialog = {
	children?: ReactNode | undefined;
	isError: boolean;
	nextStep?: "cart" | "preview";
} & Pick<ComponentProps<typeof ConfirmDialog>, "onCancel" | "onOk"> &
	ComponentProps<typeof Modal>;

export const ProductValidationDialog: FC<IProductValidationDialog> = ({
	children,
	onCancel: onBackToProduct,
	onOk: onContinue,
	isError,
	nextStep = "cart",
	...modalProps
}) => {
	const dialogLabels = isError ? labels.errorLabels : labels.warningLabels;

	const { cancelLabel, titleLabel } = dialogLabels;

	const okLabel =
		!isError && nextStep === "preview"
			? labels.warningLabels.okLabelPreview // "continue" instead of "continue to shopping basket" for preview
			: dialogLabels.okLabel;

	return !isError && cancelLabel ? (
		<ConfirmDialog
			onCancel={onBackToProduct}
			onOk={onContinue}
			okLabel={okLabel}
			cancelLabel={cancelLabel}
			titleLabel={titleLabel}
			{...modalProps}
		>
			{children}
		</ConfirmDialog>
	) : (
		<AlertDialog
			onOk={onBackToProduct}
			okLabel={okLabel}
			titleLabel={titleLabel}
			{...modalProps}
		>
			{children}
		</AlertDialog>
	);
};
ProductValidationDialog.displayName = "ProductValidationDialog";
